export enum ERRORS_CODE {
  INCORRECT_CREDENTIALS = 'INCORRECT_CREDENTIALS',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  EMAIL_NOT_EXISTS = 'EMAIL_NOT_EXISTS',
  EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
  EMAIL_INVALID_FORMAT = 'EMAIL_INVALID_FORMAT',
  CURRENT_PASSWORD_DOESNT_MATCH = 'CURRENT_PASSWORD_DOESNT_MATCH',
  OLD_AND_NEW_PASSWORD_AT_SAME = 'OLD_AND_NEW_PASSWORD_AT_SAME',
  SHOULD_CONTAIN_ONLY_10_OR_12_NUMBERS = 'SHOULD_CONTAIN_ONLY_10_OR_12_NUMBERS',
  SNILS_SHOULD_BE_11_DIGITS = 'SNILS_SHOULD_BE_11_DIGITS',
  OGRNIP_SIZE_SHOULD_BE_15_DIGITS = 'OGRNIP_SIZE_SHOULD_BE_15_DIGITS',
  INVALID_CHECKSUM = 'INVALID_CHECKSUM',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  CSRF_TOKEN_MISMATCH = 'CSRF token mismatch.',
  EMAIL_SHOULD_BE_UNIQUE = 'EMAIL_SHOULD_BE_UNIQUE',
  PHONE_SHOULD_BE_UNIQUE = 'PHONE_SHOULD_BE_UNIQUE',
}

export const ERRORS = {
  [ERRORS_CODE.INCORRECT_CREDENTIALS]: 'Логин или пароль не верен',
  [ERRORS_CODE.INVALID_CREDENTIALS]: 'Логин или пароль не верен',
  [ERRORS_CODE.EMAIL_NOT_EXISTS]: 'Аккаунт с таким email не зарегистрирован',
  [ERRORS_CODE.EMAIL_NOT_VERIFIED]: 'Подтвердите почту',
  [ERRORS_CODE.EMAIL_INVALID_FORMAT]: 'Почта имеет некорректный формат',
  [ERRORS_CODE.CURRENT_PASSWORD_DOESNT_MATCH]: 'Пароль не верен',
  [ERRORS_CODE.OLD_AND_NEW_PASSWORD_AT_SAME]:
    'Новый пароль не должен совпадать с текущим',
  [ERRORS_CODE.SHOULD_CONTAIN_ONLY_10_OR_12_NUMBERS]: 'Некорректный формат',
  [ERRORS_CODE.SNILS_SHOULD_BE_11_DIGITS]: 'Должен содержать 11 цифр',
  [ERRORS_CODE.OGRNIP_SIZE_SHOULD_BE_15_DIGITS]: 'Должен содержать 11 цифр',
  [ERRORS_CODE.INVALID_CHECKSUM]: 'Неверное значение',
  [ERRORS_CODE.EMAIL_SHOULD_BE_UNIQUE]:
    'Аккаунт с таким email уже зарегистрирован',
  [ERRORS_CODE.PHONE_SHOULD_BE_UNIQUE]:
    'Аккаунт с таким номером уже зарегистрирован',
}
